<template>
  <span>
    <v-chip
      v-if="item.lect_or_prac === 'ป'"
      class="white--text"
      color="black"
      width="100"
      x-small
    >
      {{ $t("lect_or_prac_chip.practice") }}
    </v-chip>
    <v-chip
      v-if="item.lect_or_prac === 'ท'"
      class="white--text"
      color="light-blue accent-4"
      width="100"
      x-small
    >
      {{ $t("lect_or_prac_chip.lecture") }}
    </v-chip>
  </span>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
    },
  },
};
</script>
